// extracted by mini-css-extract-plugin
export default {"formControl":"email-verify_formControl__xA8Pf"};